import { render, staticRenderFns } from "./AuthFormCheckbox.vue?vue&type=template&id=2b3f32b6&scoped=true&"
import script from "./AuthFormCheckbox.vue?vue&type=script&lang=js&"
export * from "./AuthFormCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AuthFormCheckbox.vue?vue&type=style&index=0&id=2b3f32b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3f32b6",
  null
  
)

export default component.exports